module.exports = __webpack_public_path__ + "fonts/VISBYROUNDCF-MEDIUM.672c7c00.OTF";